<template>
  <div class="left-middle">
    <div class="item">
      <img src="../../../assets/province/male.png" class="icon" />
      <div class="row">
        <div class="label">参与率</div>
        <div class="val">{{sex_detail.male.participation_rate}}%</div>
      </div>
      <div class="row">
        <div class="label">合格率</div>
        <div class="val">{{sex_detail.male.qualified_rate}}%</div>
      </div>
    </div>
    <div class="item">
      <img src="../../../assets/province/female.png" class="icon" />
      <div class="row">
        <div class="label">参与率</div>
        <div class="val">{{sex_detail.female.participation_rate}}%</div>
      </div>
      <div class="row">
        <div class="label">合格率</div>
        <div class="val">{{sex_detail.female.qualified_rate}}%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sex_detail: {
      default() {
        return {
          male: { gender: '男', num: 0, participation_rate: 0, qualified: 0, qualified_rate: 0 },
          female: { gender: '女', num: 0, participation_rate: 0, qualified: 0, qualified_rate: 0 },
        }
      },
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.left-middle {
  padding: 20px;
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    + .item {
      margin-top: 30px;
    }
    .icon {
      width: 66px;
      height: 66px;
    }
    .row {
      width: 122px;
      .label {
        opacity: 0.65;
        font-size: 18px;
        color: #ffffff;
        font-weight: 400;
      }
      .val {
        font-size: 30px;
        color: #ffffff;
        margin-top: 8px;
      }
    }
  }
}
</style>
